<template>
  <v-app id="app">
    <v-navigation-drawer v-model="drawer" clipped fixed app class="nav body-2 d-print-none" width="360">
      <v-list>
      <v-divider></v-divider>
      <v-list-item to="/misc/impressum-und-datenschutz" key="impud">
          <v-list-item-content>Impressum und Datenschutz</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <div class="tc"><p>Inhalte</p></div>
      <v-list-item to="/" @click.stop="drawer = false">
        <v-list-item-icon>
            <v-icon color="black">{{home}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Hauptseite</v-list-item-content>
      </v-list-item>
      <v-list-item to="/misc/autorenliste">
        <v-list-item-icon>
            <v-icon color="black">{{accounts}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Autorenliste</v-list-item-content>
      </v-list-item>
      <v-list-item to="/misc/uebersetzerliste">
        <v-list-item-icon>
            <v-icon color="black">{{trans}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Übersetzerliste</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item :to="'/' + sel[Math.floor(Math.random() * 274)]">
        <v-list-item-icon>
            <v-icon color="black">{{dice}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Zufälliges Werk</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <div class="tc"><p>Weiteres Projekt</p></div>
      <v-list-item href="https://lernzettel.org/" target="_blank" rel="noopener">
        <v-list-item-icon>
            <v-icon color="black">{{lightbulb}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Lernzettel</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      </v-list>
      <div class="tc"><p>Minimalistische Webanalyse durch <a href="https://plausible.io/" target="_blank" rel="noopener">Plausible</a></p></div>
      <v-divider></v-divider>
      <div class="tc"><p>»Gegen den Geist mit Gewalt vorzugehen, ist wie das Einfangen von Sonnenstrahlen; womit man sie auch zudecken will, immer kommen sie obenauf.« <br><br>Leo Tolstoi</p></div>
      <v-divider></v-divider>
    </v-navigation-drawer>

    <v-app-bar app fixed dense flat clipped-left class="tb d-print-none">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" aria-label="Menü"></v-app-bar-nav-icon>
      <router-link to="/"><v-toolbar-title to="/">Castellio</v-toolbar-title></router-link>
      <v-spacer></v-spacer>
      <v-btn icon @click="$vuetify.theme.dark=!$vuetify.theme.dark" aria-label="Theme ändern">
              <v-icon>{{theme}}</v-icon>
      </v-btn>
      <!--<v-btn icon href="https://ko-fi.com/lernzettel" aria-label="spenden" target="_blank" rel="noopener">
              <v-icon>{{spenden}}</v-icon>
      </v-btn> -->
      <v-btn icon v-if="sharable()" @click="share" aria-label="teilen" color="#2ecc71">
              <v-icon>{{sharer}}</v-icon>
      </v-btn>
      <v-btn icon @click="print" aria-label="drucken">
              <v-icon>{{printer}}</v-icon>
      </v-btn>
      <v-btn icon v-on:click="navigate" aria-label="Suche">
              <v-icon>{{magnify}}</v-icon>
      </v-btn>
    </v-app-bar>

    <vue-progress-bar></vue-progress-bar>
    
     <v-content class="content">
      <v-container fluid fill-height>
        <v-layout>
          <v-flex>
            <!--<v-alert v-if="showwarning" class="d-print-none" outlined type="info" elevation="10" dense dismissible>Mit der Nutzung dieser Seite erklären Sie sich mit der Verwendung von Google Analytics bzw. der Datenschutzerklärung für einverstanden. | <router-link to="/datenschutzerklarung">Datenschutzerklärung</router-link> | <router-link to="/funktionen/google-analytics-deaktivieren">Google Analytics deaktivieren</router-link></v-alert>-->
            <main>
              <router-view id="print"></router-view>
            </main>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <!--<div v-if="this.$Progress.$vm.RADON_LOADING_BAR.percent==100">{{showwarning=true}}</div>-->
  </v-app>
</template>

<style scoped>
.tc{
  text-align: center;
}
@media print {
  .content {padding: 0 !important; z-index: 10;}
}
</style>


<script>
  import { mdiShareVariant, mdiTranslate } from '@mdi/js'
  import { mdiAccountMultiple } from '@mdi/js'
  import { mdiDice5Outline } from '@mdi/js'
  import { mdiHome } from '@mdi/js'
  import { mdiPrinter } from '@mdi/js'
  import { mdiMagnify } from '@mdi/js'
  import { mdiBookMultiple } from '@mdi/js'
  import { mdiClock } from '@mdi/js'
  import { mdiPiggyBank } from '@mdi/js'
  import { mdiLightbulb } from '@mdi/js'
  import { mdiThemeLightDark } from '@mdi/js'
  export default {
    data: () => ({
      sharer: mdiShareVariant,
      trans: mdiTranslate,
      accounts: mdiAccountMultiple,
      home: mdiHome,
      printer: mdiPrinter,
      magnify: mdiMagnify,
      books: mdiBookMultiple,
      rocket: mdiClock,
      spenden: mdiPiggyBank,
      lightbulb: mdiLightbulb,
      theme: mdiThemeLightDark,
      dice: mdiDice5Outline,
      drawer: null,
      printer_off: true,
      showwarning: false,
      sel: [30613,96,27741,31705,467,26043,30860,37057,23554,34332,35839,45988,26619,34138,18919,23848,49836,27835,22669,2328,17731,30071,31924,30007,35801,5325,857,37682,21737,1002,383,10274,37585,35800,17072,5782,37993,42188,17395,28667,29819,24449,1819,2913,754,15885,18242,6655,25188,31918,18793,19955,21386,36067,7320,11995,35668,37133,5943,25967,30463,14069,14811,30184,39223,18986,3628,34603,28981,31811,3143,5808,12020,3733,1021,13303,1822,39748,20312,2106,24349,31367,40392,5013,40880,15182,40469,9168,687,16324,21472,2808,7244,9501,37111,14964,42500,13236,21527,11928,5647,16878,32601,28507,9311,18927,29656,33291,9944,20607,25305,770,20634,32543,4280,40709,37280,2893,36932,26158,17620,15725,2684,2365,28230,46493,17351,10378,17130,16135,17282,1661,27057,1968,223,22565,7222,33811,37507,20716,11521,1726,50903,13543,24082,12214,24693,38417,26567,40272,40532,816,21233,13654,17168,18938,39855,31973,39167,27448,14475,18275,38728,18617,6516,16305,25008,29971,17730,38158,34900,32576,33421,36056,715,19413,27334,2786,27640,21844,33248,24589,36347,25531,5785,21994,17142,22032,3140,30488,28122,39133,10724,36105,22387,966,15805,25292,26477,887,19988,33349,22872,17214,9215,26943,868,55857,36275,29287,41140,18343,1862,5171,32057,30540,18740,21900,24347,8081,11774,27666,12186,4043,15661,29630,11099,25556,37272,64427,19414,5793,7576,22726,34348,650,7574,26112,22748,34229,19608,33679,11489,35256,29995,24811,18210,24967,23219,52601,23748,308,4623,30167,31304,12391,2449,27162,1286,31277,40926,34871,8079,21768,29886,38865,30341,5628,5927,9080,33222,20852,19389,21419]
      }),
    props: {
      source: String
    },
    methods: {
      navigate: function(){
        if(this.$router.currentRoute.path!=='/funktionen/suche'){
        this.$router.push('/funktionen/suche')
        } else{
        this.$router.go(-1)
        }
      },
      print: function(){
        try {
          // Print for Safari browser
          document.execCommand('print', false, null)
        } catch {
          window.print()
        }
      },
      sharable: function(){
        if(navigator.share){
          return true;
        } else {
          return false;
        }
      },
      share: function(){
        if(navigator.share){
          navigator.share({
            url: "https://castellio.de" + this.$router.currentRoute.path
          })
        }
      }
    },
    metaInfo: {
      title: 'Castellio',
      // all titles will be injected into this template
      titleTemplate: '%s'
    },
    created(){
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()

    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      this.$Progress.start()
      next()
    })
    }
  }
</script>
